const CODE_STATUSES = ['sms_sent', 'email_sent', 'sms_failed']
const FAILED_CODE_STATUSES = ['sms_failed', 'email_failed']
const CODE_DONE_LABEL_KEYS: Record<string, string> = {
  sms_sent: 'additionalSales:leadCarbonOffset.code_sent_sms',
  email_sent: 'additionalSales:leadCarbonOffset.code_sent_email',
  sms_delivered: 'additionalSales:leadCarbonOffset.code_delivered_sms',
}

export const isFailedCodeStatus = (codeStatus?: string | null): boolean =>
  FAILED_CODE_STATUSES.includes(codeStatus ?? '')

export const documentStepLabelKey = (isDocumentLoading: boolean): string => {
  if (isDocumentLoading) return 'additionalSales:leadCarbonOffset.signature_step_document'

  return 'additionalSales:leadCarbonOffset.document_created'
}

export type SignatureStepState = 'done' | 'loading' | 'failed'

export const signatureStepState = (isLoading: boolean, isFailed: boolean): SignatureStepState => {
  if (isLoading) return 'loading'
  if (isFailed) return 'failed'

  return 'done'
}

export const codeStepLabelKey = (isCodeFailed: boolean, codeStatus?: string | null): string => {
  if (isCodeFailed && codeStatus === 'email_failed') return 'additionalSales:leadCarbonOffset.email_code_failed'
  if (isCodeFailed) return 'additionalSales:leadCarbonOffset.sms_code_failed'

  if (!codeStatus) return 'additionalSales:leadCarbonOffset.signature_step_code'

  return (
    CODE_DONE_LABEL_KEYS[codeStatus] ?? CODE_DONE_LABEL_KEYS[codeStatus.startsWith('email') ? 'email_sent' : 'sms_sent']
  )
}

interface SignatureAttributes {
  code_status?: string | null
  document_status?: string | null
  passcode_required?: boolean | null
  passcode_set_at?: string | null
}

export interface SignatureSaleData extends SignatureAttributes {
  statusCode?: string | null
  infoAttributes?: SignatureAttributes | null
}

export interface SignatureStatus {
  codeStatus: string | null
  isDocumentLoading: boolean
  isCodeLoading: boolean
  isSigned: boolean
  isCodeFailed: boolean
  showSignatureProcess: boolean
  isSignLinkReady: boolean
}

export const getSignatureStatus = (data: SignatureSaleData): SignatureStatus => {
  const saleStatus = data.statusCode ?? ''
  const isSigned = saleStatus === 'signed'
  const legacyCodeStatus = CODE_STATUSES.includes(saleStatus) ? saleStatus : null
  const codeStatus = data.infoAttributes?.code_status ?? data.code_status ?? legacyCodeStatus
  const documentStatus = data.infoAttributes?.document_status ?? data.document_status ?? null
  const isPasscodeRequired = data.infoAttributes?.passcode_required ?? data.passcode_required ?? false
  const passcodeSetAt = data.infoAttributes?.passcode_set_at ?? data.passcode_set_at ?? null

  return {
    codeStatus,
    isDocumentLoading: !isSigned && documentStatus === null,
    isCodeLoading: !isSigned && codeStatus === null,
    isSigned,
    isCodeFailed: !isSigned && isFailedCodeStatus(codeStatus),
    showSignatureProcess: isSigned || documentStatus === 'created' || codeStatus !== null,
    // PandaDoc never asks for a code set after the page was opened, so wait until browsery has set it
    isSignLinkReady: !isPasscodeRequired || passcodeSetAt !== null,
  }
}
